import { Component } from '@angular/core';

@Component({
  selector: 'app-switch-arrow',
  imports: [],
  templateUrl: './switch-arrow.component.html',
  styleUrl: './switch-arrow.component.scss',
})
export class SwitchArrowComponent {

}
